import { gql } from "@apollo/client";

export const TRACK_PITCH_PAGE_VIEW = gql`
  mutation TrackPitchPageView($pitchPageId: ID!) {
    trackPitchPageView(pitchPageId: $pitchPageId) {
      success
    }
  }
`;

export const TRACK_PITCH_PAGE_CLICK_EVENT = gql`
  mutation TrackPitchPageClickEvent($pitchPageId: ID!) {
    trackPitchPageClickEvent(pitchPageId: $pitchPageId) {
      success
    }
  }
`;
